import {Button, IconButton, Stack, TextField, Tooltip} from '@mui/material';
import {Info} from '@mui/icons-material';
import MarkdownContentRenderer from '../MarkdownContentRenderer/MarkdownContentRenderer';

export interface TextOptionWithRemoveProps {
  /** The index of the option */
  index: number;
  /** The value of the option */
  value: string;
  /** The function to call when the value changes */
  onChange: (index: number, value: string) => void;
  /** The function to call when the option is removed */
  onRemove?: (index: number) => void;
  /** Whether to show the rendered content */
  showRender?: boolean;
  /** show the render in a tooltip */
  tooltipRender?: boolean;
}

export default function TextOptionWithRemove({
  index,
  value,
  onChange,
  onRemove,
  showRender,
  tooltipRender,
}: TextOptionWithRemoveProps) {
  return (
    <Stack
      direction="column"
      spacing={1}
      alignItems="center"
      justifyContent="center"
      data-testid="text-option-with-remove"
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{width: '100%'}}>
        <TextField
          fullWidth
          label={`Option ${index + 1}`}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(index, e.target.value)}
        />
        {onRemove && (
          <Button variant="outlined" color="error" onClick={() => onRemove(index)} size="small">
            Remove
          </Button>
        )}
        {tooltipRender && (
          <Tooltip title={<MarkdownContentRenderer content={value || ''} />} arrow placement="top">
            <IconButton size="small" color="primary">
              <Info fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {showRender && <MarkdownContentRenderer content={value || ''} sx={{bgcolor: 'grey.100', width: '100%', p: 2}} />}
    </Stack>
  );
}
